<template>
  <div class="cooling-efficiency-parameters">
    <b-row v-if="showEmptyList">
      <b-col>
        <s-empty-list/>
      </b-col>
    </b-row>
    <view-edit-panel
      v-else
      v-model="parameters"
      permission-to-edit="PER013"
      saving-success-code="MS032"
      hide-edit-when-without-permission
      :disable-save="invalidForm"
      :loading="isLoading"
      @changing="save"
    >
      <b-container
        fluid
        slot-scope="data"
      >
        <b-row
          v-if="isLoading"
          class="cooling-efficiency-parameters__loader"
          align-h="center"
          align-v="center"
        >
          <s-loader size="lg" />
        </b-row>
        <b-row v-else>
          <parameters-form
            :parameters="data.item"
            :saving="data.saving"
            :edit-mode="data.editing"
            @form-status-update="formStatusUpdate"
          />
        </b-row>
      </b-container>
    </view-edit-panel>
  </div>
</template>

<script>
import ViewEditPanel from '@/components/ViewEditPanel';
import Service from '@/domain/services/installation/engineering/coolingEfficiency/coolingEfficiencyService';
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import ParametersForm from './ParametersForm';

export default {
  name: 'CoolingEfficiencyParametersTab',
  components: { ParametersForm, ViewEditPanel },
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    parameters: null,
    invalidForm: false,
    loadingSave: false,
    loadingGet: false,
  }),
  computed: {
    showEmptyList() {
      return !this.isLoading && !this.parameters;
    },
    isLoading() {
      return this.loadingSave || this.loadingGet;
    },
  },
  created() {
    this.initEvents();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.removeEvents();
  },
  methods: {
    initEvents() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    removeEvents() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    getParameters(showLoading = false) {
      const { assetModuleId } = this.$route.params;
      if (showLoading) {
        this.loadingGet = true;
      }
      Service.getParameters(assetModuleId).then((response) => {
        this.parameters = response;
      }).finally(() => {
        this.loadingGet = false;
      });
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.status?.lastUpdate) return;
      this.getParameters(showLoading);
    },
    save({ newValue, accept, reject }) {
      const { assetModuleId } = this.$route.params;
      this.loadingSave = true;
      return Service.putParameters(assetModuleId, newValue)
        .then(() => {
          this.getParameters(true);
          accept();
        })
        .catch(reject)
        .finally(() => {
          this.loadingSave = false;
        });
    },
    formStatusUpdate(value) {
      this.invalidForm = value;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.cooling-efficiency-parameters
  &__loader
    margin: 20px 0
::v-deep
  .view-edit-panel
    +media-min-md
      &__btns > div:last-child
        padding-right: 0
</style>
